import React from 'react';
import './App.css';

function fetchWithTimeout(url: string, options: any) {
  const timeout = options.timeout;

  delete options.timeout;

  return new Promise((resolve, reject) => {
    if (typeof timeout === 'number') {
      setTimeout(() => { reject(new Error('请求超时')) }, timeout);
    }

    fetch(url, options).then(resolve, reject);
  })
}

async function fetchData(url: string, body: any) {
  try {
    const { loginToken, versionName, versionCode, appPkg, deviceId, osVersion } = globalUserInfo;
    let options: any = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'APP-TOKEN': loginToken,
        'VERSION-NAME': versionName,
        'VERSION-CODE': versionCode,
        'APP-OS-VERSION': osVersion,
        'PKG': appPkg,
        'DEVID': deviceId,
      },
      timeout: 10000,
    };
    if (body) {
      Object.keys(body).forEach(key => {
        if (body[key] === null || body[key] === undefined) delete body[key];
      });
    }
    options.body = body ? JSON.stringify(body) : '{}';

    // log(url);
    // log(JSON.stringify(options));

    const result: any = await fetchWithTimeout(url, options);
    const json = await result.json();

    // log(JSON.stringify(json));

    if (json.code === 1) {
      return json.data;
    } else {
      throw json;
    }
  } catch (e) {
    console.error(e);
  }
}

const mockImg = "https://img.asman.com.cn/assets/1561602306166_75846.png";

interface NoviceTask {
  id: string,
  url: string,
  urlType: number,
  taskName: string,  // 名称
  status: number,
  taskGenre: number,
  coin: number,  // 奖励分
  taskCount: number,  // 总数
  taskProgress: number,  // 进展
  remark: string,  // 描述
  showDesc: boolean,  // 是否展开描述
  type: number,
  advRewardVideoRsp: object,
  statisticsType: number,
  codeTag: number,
}

interface Banner {
  bannerId: string,
  title: string,
  subtitle: string,
  bannerKey: string,
  taskGenre: number,
  coin: number,  // 奖励分
  taskCount: number,  // 总数
  taskProgress: number,  // 进展
  remark: string,  // 描述
  showDesc: boolean,  // 是否展开描述
  urlType: number,
  type: number,
  advRewardVideoRsp: object,
  statisticsType: number,
  url: string,
  status: number,
  codeTag: number,
}

const env = 'prod';

const hostMap = {
  test: 'http://121.196.175.145:8090/delevin',
  prod: 'http://api.qubuduo.com',
}

const host = hostMap[env];

const indexImg = "http://image.qubuduo.cn/task_icon.png";
const coinImg = "http://image.qubuduo.cn/WX20210114-154820%402x.png";
const arrowImg = "http://image.qubuduo.cn/1578895308386_4513.png";

function log(message: string | Event) {
  // alert(message);
}

// @ts-ignore
const bridge = window.renwuzhuan;

bridge.setWindowHeight(1000);
let containerHeight = 1000;

let app: App | undefined;

let globalUserInfo: any = { init: true };

const btnText = {
  0: '赚奖励',
  1: '已完成',
  2: '待领取',
};

interface State {
  noviceList: NoviceTask[],
  bannerList: Banner[],
}
class App extends React.PureComponent<{}, State> {

  constructor(props: any) {
    super(props);
    app = this;
  }

  state = {
    noviceList: [],
    bannerList: [],
  }

  async requestApiRefreshPage() {
    const { loginUserId: userId } = globalUserInfo;
    // 新手任务列表
    const noviceList = await fetchData(`${host}/app/v1/getNoviceTask`, { userId });
    // 每日任务列表
    const bannerList = await fetchData(`${host}/app/v1/getBanners`, { userId });
    app?.setState({
      noviceList,
      bannerList,
    });
  }

  render() {
    const { noviceList, bannerList } = this.state;
    return (
      <div className="App">
        <div className="content" id="h5container">
          {noviceList && noviceList.length > 0 && (
            <div className="taskModuleCon">
              <div className="titleCon">
                <img
                  src={indexImg}
                  className="titleIconImg"
                />
                <span className="titleText">新手任务</span>
              </div>
              {noviceList.map((item: NoviceTask, index) => (
                <div className="itemCon" key={index}
                     onClick={(e) => {
                       e.stopPropagation();
                       if (!item.url && item.urlType == 4 && item.status !== 2 && item.status !== 2) {
                         app?.showVideoAdv(item.id, JSON.stringify({ codeTag: item.codeTag }), 5, item.taskGenre);
                       } else {
                         app?.startNoobTask(item.url, item.urlType, item.id, item.taskName, item.status, item.taskGenre)}
                       }
                     }
                >
                  <div className="itemUpCon">
                    <div className="itemLeftTitleAndProgress">
                      <span className="itemTitle">{item.taskName}</span>
                      <span className="itemProgress">完成  {item.taskProgress}/{item.taskCount}</span>
                    </div>
                    <div className="itemMidIcon">
                      <span className="iconNum">+{item.coin}</span>
                      <img
                        src={coinImg}
                        className="iconImg"
                      />
                    </div>
                    <div className="itemRightBtnAndArrow">
                      <div
                        className="btn"
                        style={item.status == 1 ? {background: '#cfcfcf'} : {}}
                      >{
                        // @ts-ignore
                        btnText[item.status]
                      }</div>
                      <img
                        className={(item.showDesc && item.remark) ? 'arrowUpImg' : 'arrowDownImg'}
                        src={arrowImg}
                        onClick={(e) => {
                          e.stopPropagation();
                          item.showDesc = !item.showDesc;
                          app?.forceUpdate();
                        }}
                      />
                    </div>
                  </div>
                  {(item.showDesc && item.remark) && <div className="itemDownCon">{item.remark}</div>}
                </div>
              ))}
            </div>
          )}
          {bannerList && bannerList.length > 0 && (
            <div className="taskModuleCon">
              <div className="titleCon">
                <img
                  src={indexImg}
                  className="titleIconImg"
                />
                <span className="titleText">日常任务</span>
              </div>
              {bannerList.map((item: Banner, index) => (
                <div className="itemCon" key={index} onClick={(e) => {
                  e.stopPropagation();
                  if (item.type == 5 && item.urlType == 4 && item.status !== 2) {
                    app?.showVideoAdv(item.bannerId, JSON.stringify({ codeTag: item.codeTag }), 2, item.taskGenre);
                  } else {
                    app?.startDayTask(item.type, item.status, item.urlType, item.url, item.title, item.bannerId, item.bannerKey, item.taskGenre);
                  }
                }}>
                  <div className="itemUpCon">
                    <div className="itemLeftTitleAndProgress">
                      <span className="itemTitle">{item.title}</span>
                      {item.type === 5 ? (
                        <span className="itemProgress">完成  {item.taskProgress}/{item.taskCount}</span>
                      ) : (
                        <span className="itemProgress">{item.subtitle || ''}</span>
                      )}
                    </div>
                    <div className="itemMidIcon">
                      <span className="iconNum">+{item.coin}</span>
                      <img
                        src={coinImg}
                        className="iconImg"
                      />
                    </div>
                    <div className="itemRightBtnAndArrow">
                      <div
                        className="btn"
                        style={item.status == 1 ? {background: '#cfcfcf'} : {}}
                      >{
                        // @ts-ignore
                        btnText[item.status]
                      }</div>
                      <img
                        className={(item.showDesc && item.remark) ? 'arrowUpImg' : 'arrowDownImg'}
                        src={arrowImg}
                        onClick={(e) => {
                          e.stopPropagation();
                          item.showDesc = !item.showDesc;
                          app?.forceUpdate();
                        }}
                      />
                    </div>
                  </div>
                  {item.showDesc && <div className="itemDownCon">{item.remark}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // 从客户端获取参数
  getLoginUserInfo() {
    bridge.getLoginUserInfo();
  }
  // 新手任务调用方法
  startNoobTask(url: string, urlType: number, id: string, taskName: string, status: number, taskGenre: number) {
    // log(`status: ${status}`);
    bridge.startNoobTask(url, urlType, id, taskName, status, taskGenre);
  }
  // 每日任务调用方法
  startDayTask(type: number, status: number, urlType: number, url: string, taskName: string, bannerId: string, bannerKey: string, taskGenre: number) {
    bridge.startDayTask(type, status, urlType, url, taskName, bannerId, bannerKey, taskGenre);
  }
  // 设置高度
  setWindowHeight(height: number) {

    const devicePixelRatio = window.devicePixelRatio;  // css px 和 物理像素的 比值
    let deviceHeight = height + 40;
    if (devicePixelRatio) {
      deviceHeight = deviceHeight * devicePixelRatio;
    }
    bridge.setWindowHeight(deviceHeight);

    // bridge.setWindowHeight(height * 3.2);

    containerHeight = height;
  }
  // 看视频调用方法：新手任务： !url && urlType === 4       每日任务  type == 5 && urlType == 4
  showVideoAdv(taskId: string, json: string, statisticsType: number, taskGenre: number) {
    // log('showVideoAdv');
    bridge.showVideoAdv(taskId, json, statisticsType, taskGenre);
  }

  // 客户端回调，把参数给进来，拿到参数后刷新页面
  androidUserInfo(userInfoJSON: string) {
    // log(userInfoJSON);
    let userInfo;
    try {
      userInfo = JSON.parse(userInfoJSON);
    } catch (e) {
      log(e);
      userInfo = {};
    }
    globalUserInfo = userInfo;
    app?.requestApiRefreshPage();
  }
  // 提供给客户端的刷新方法
  androidRefreshPage() {
    // log('androidRefreshPage');
    /*if (!app?.hasUserInfo()) {
      setTimeout(() => app?.requestApiRefreshPage(), 1000);
      return;
    }
    app?.requestApiRefreshPage();*/
    // 调用 getLoginUserInfo 获取列表
    app?.getLoginUserInfo();
  }
  // 内部自己调的刷新方法
  // intervalRefresh() {
  //   // log('intervalRefresh');
  //   setTimeout(() => app?.requestApiRefreshPage(), app?.hasUserInfo() ? 0 : 500);
  // }

  // 判断是否有 userInfo
  hasUserInfo() {
    if (globalUserInfo.init) {
      return false
    }
    const userId = globalUserInfo?.loginUserId;
    if (userId === null || userId === undefined || userId === 'undefined' || userId === 'null') {
      return false;
    }
    return true;
  }

  listenError() {
    window.onerror = (e) => log(e);
  }

  // @ts-ignore
  intervalId;
  listenContainerHeight() {
    const container = document.querySelector('#h5container');
    this.intervalId = setInterval(() => {
      if (container && (container.clientHeight !== containerHeight)) {
        // log(container.clientHeight.toString());
        app?.setWindowHeight(container.clientHeight);
      }
    }, 500);
  }

  componentDidMount() {
    app?.listenError();
    app?.listenContainerHeight();
    // 把回调挂载到 bridge 上面
    // @ts-ignore
    window.androidUserInfo = app?.androidUserInfo;
    // @ts-ignore
    window.refreshPage = app?.androidRefreshPage;
    // 调用 getLoginUserInfo 获取列表
    // app?.getLoginUserInfo();

    // 首次刷新页面
    // app?.intervalRefresh();
  }

  componentWillUnmount() {
    this.intervalId && clearInterval(this.intervalId);
  }
}

export default App;
